var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkAsInteresting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0H4ZM14.625 16.4141H15.25V12.1964H14.625C14.2798 12.1964 14 11.9341 14 11.6105V10.2109C14 9.88732 14.2798 9.625 14.625 9.625H18.125C18.4702 9.625 18.75 9.88732 18.75 10.2109V16.4141H19.375C19.7202 16.4141 20 16.6764 20 17V18.4141C20 18.7377 19.7202 19 19.375 19H14.625C14.2798 19 14 18.7377 14 18.4141V17C14 16.6764 14.2798 16.4141 14.625 16.4141ZM17 4C15.7574 4 14.75 4.94438 14.75 6.10938C14.75 7.27437 15.7574 8.21875 17 8.21875C18.2427 8.21875 19.25 7.27437 19.25 6.10938C19.25 4.94438 18.2426 4 17 4ZM7.44828 10.7586H9.10346V14.069H12.4138V15.7241H9.10346V19.0345H7.44828V15.7241H4.13794V14.069H7.44828V10.7586Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkAsInteresting);
export default __webpack_public_path__ + "static/media/MarkAsInteresting.9096f62a499cb5643affbe2ef62b4cc6.svg";
export { ForwardRef as ReactComponent };